/* ==========================================================================
   Elevate Floors — Tell us about your floors

   Uma responsabilidade só: manter o campo oculto dos SERVIÇOS em dia com os
   checkboxes. É múltipla escolha e o contact form do Shopify entrega melhor um
   valor único e legível ("Refinishing, Stairs") do que um array.

   A METRAGEM não passa por aqui: é um grupo de <input type="radio"> com name
   próprio e required, então ela envia sozinha e valida no navegador. Era o
   ponto que o handoff levantava — required não funciona em campo oculto — e a
   saída escolhida foi a segunda que ele sugere, a dos radios escondidos.

   Se este arquivo não carregar, o formulário continua enviando: só os serviços
   deixam de ir junto. Nenhum campo obrigatório depende de JS.
   ========================================================================== */
(function () {
  'use strict';

  function initRoot(root) {
    var hidden = root.querySelector('[data-services-value]');
    if (!hidden) return;

    var boxes = root.querySelectorAll('[data-service]');

    function sync() {
      var picked = [];
      boxes.forEach(function (b) {
        if (b.checked) picked.push(b.value);
      });
      hidden.value = picked.join(', ');
    }

    boxes.forEach(function (b) {
      if (b._efBound) return;
      b._efBound = true;
      b.addEventListener('change', sync);
    });

    // A pré-seleção da página vem marcada pelo Liquid. Sem esta chamada o chip
    // apareceria aceso e o lead chegaria sem o serviço.
    sync();
  }

  function init() {
    document.querySelectorAll('[data-ef-estimate]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
